import { ReducerBuilder } from './reducerBuilder';
import { AccountLinksState } from 'acscp/store';
import { AccountLinksRequest } from 'acscp/api/requests';
import { AccountLinksList } from 'acscp/api/models/accountLinksList';

export const accountLinksReducer =
    new ReducerBuilder<AccountLinksState>({accountLinks: []})
        .successfulRequestCase(AccountLinksRequest, (state, accountLinksList: AccountLinksList) => ({
            accountLinks: accountLinksList.map(accountLink => accountLink),
        }))
        .build();
